import {
  PaymentNotConfiguredError,
  type CheckoutSession,
  type CheckoutSessionInput,
  type IPaymentService,
} from '../../interfaces/src';

/** Placeholder until Flouci/Konnect is wired. The billing UI catches the
 *  thrown PaymentNotConfiguredError and shows a "coming soon" state instead
 *  of crashing. */
export class StubPaymentService implements IPaymentService {
  // Default to flouci for the marketing copy, but it's a stub so this
  // doesn't actually pick anything.
  readonly provider = 'flouci' as const;

  async createCheckoutSession(_input: CheckoutSessionInput): Promise<CheckoutSession> {
    throw new PaymentNotConfiguredError(
      'Aucun fournisseur de paiement n\'est encore configuré. Contactez le support pour activer votre abonnement.',
    );
  }
}
